if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.debug = false;
        this.observer = null;
        if (this.debug) console.log('ProductCard constructor');
        this.sku = false;
        this.model = false;
        // if this.getAttribute('data-selected-variant-id') has a value
        if (this.getAttribute('data-selected-variant-id')) {
          this.product_id = this.getAttribute('data-selected-product-id');
          this.variant_id = this.getAttribute('data-selected-variant-id');
          this.disable_pickers = true;
        } else {
          this.product_id = this.getAttribute('data-product-id');
          this.variant_id = this.getAttribute('data-variant-id');
          this.disable_pickers = false;
        }
        this.variant_available = false;
        this.finish = false;
        this.cart_title = false;
        this.swipers = {};
        this.selected_product_json = false;
        this.setupObserver();
      }

      /**
       * Helper method to find a specification value by title from an array of specs
       * Uses dynamic DOM-based matching to handle different languages
       *
       * @param {Array} specs - Array of specification objects with title and value properties
       * @param {string} selector - CSS selector for the spec element to match (e.g., '[spec-product-capacity]')
       * @returns {string} The found specification value or empty string
       */
      findSpecValue(specs, selector) {
        if (!Array.isArray(specs) || !selector) {
          return '';
        }

        // Find the spec value element in the DOM
        const specValueElement = document.querySelector(selector);
        if (!specValueElement) {
          if (this.debug) console.warn(`Spec value element not found for selector: ${selector}`);
          return '';
        }

        // Find the container that holds both title and value
        const specContainer = specValueElement.closest('.product-spec__copy-inner, [data-spec]');
        if (!specContainer) {
          if (this.debug) console.warn(`Spec container not found for selector: ${selector}`);
          return '';
        }

        // Get the title from the spec container (look for .spec__row-title or similar)
        const titleElement = specContainer.querySelector('.spec__row-title, .spec-title, [class*="title"]');
        if (!titleElement) {
          if (this.debug) console.warn(`Title element not found in spec element: ${selector}`);
          return '';
        }

        const actualTitle = titleElement.textContent?.trim();
        if (!actualTitle) {
          if (this.debug) console.warn(`No title text found in element: ${selector}`);
          return '';
        }

        // Find the spec in the JSON data that matches the actual title
        const spec = specs.find((spec) => {
          if (!spec?.title) return false;
          // Case-insensitive comparison, also handle variations with/without colons
          const specTitle = spec.title.toLowerCase().trim();
          const domTitle = actualTitle.toLowerCase().trim();

          return (
            specTitle === domTitle ||
            specTitle === domTitle + ':' ||
            specTitle + ':' === domTitle ||
            specTitle.replace(':', '') === domTitle.replace(':', '')
          );
        });

        if (spec && this.debug) {
          console.log(`Found spec match: "${actualTitle}" -> "${spec.value}"`);
        } else if (!spec && this.debug) {
          console.warn(`No spec found for title: "${actualTitle}"`);
        }

        return spec?.value || '';
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.debug) console.log('ProductCard connectedCallback');
        document.addEventListener('DOMContentLoaded', () => {
          this.drop_down_lists = this.querySelectorAll('.DropdownList');
          this.selected_product_json = document.querySelector(
            `script[data-json-config-product-id="${this.product_id}"]`
          );
          this.setupFinishPicker();
          this.setupSwiperSliders(); // Call the method on DOM ready
          this.setConfiguarableProductValues(this.selected_product_json);
          this.initializeSwipers();
          if (this.getAttribute('data-selected-variant-id')) {
            this.prePickConfigurableSelections();
          }
          //find if url parameters has a model option
          const urlParams = new URLSearchParams(window.location.search);
          const model = urlParams.has('model') ? urlParams.get('model').toLocaleLowerCase() : null;
          if (model) {
            if (this.debug) console.log('click model: ', model);
            const config_model = this.querySelector('config-model [data-config-model="' + model + '"]');
            if (config_model) {
              config_model.click();
            }
          }
          //          this.updateAddOnItems();
        });
      }
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.debug) console.log('ProductCard connectedCallback');
      }

      disconnectedCallback() {}

      setConfiguarableProductValues(selected_product_variant_json, selector = 'variant', selector_value = false) {
        if (this.debug) console.log('setConfiguarableProductValues');
        let targetVariant;
        const jsonData = JSON.parse(selected_product_variant_json.innerHTML);
        if (selector == 'finish') {
          // if finish is provided, we are trying to look up this variant by finish instead of by variant_id
          targetVariant = jsonData.variants.find(function (variant) {
            return variant.finish === selector_value;
          });
        } else if (selector == 'sku') {
          targetVariant = jsonData.variants.find(function (variant) {
            return variant.sku === selector_value;
          });
        } else {
          // if finish is not provided, we are trying to look up this variant by variant_id
          const this_variant_id = this.variant_id;
          targetVariant = jsonData.variants.find(function (variant) {
            return variant.id === this_variant_id;
          });
        }
        this.selected_product_json = selected_product_variant_json;
        this.product_id = selected_product_variant_json.getAttribute('data-json-config-product-id');
        this.model = selected_product_variant_json.getAttribute('data-json-config-model').toUpperCase();
        this.cart_title = selected_product_variant_json.getAttribute('data-json-config-cart-title');
        this.variant_id = targetVariant.id;
        this.sku = targetVariant.sku;
        this.finish = targetVariant.finish;
        this.variant_available = targetVariant.available;

        // select finish based on variant_id
        const config_finish = this.querySelector('config-finish');
        const config_finish_buttons = config_finish.querySelectorAll(
          '[data-config-finish][data-config-variant-id="' + this.variant_id + '"]'
        );
        config_finish_buttons.forEach((config_button) => {
          if (config_button.getAttribute('data-config-variant-id') === this.variant_id) {
            config_button.click();
          }
        });

        // store product_id and variant_id in local storage
        window.localStorage.setItem('product_id', this.product_id);
        window.localStorage.setItem('variant_id', this.variant_id);

        if (this.debug) console.log('setConfiguarableProductValues');
        if (this.debug) console.log('this.sku: ', this.sku);
        if (this.debug) console.log('this.product_id: ', this.product_id);
        if (this.debug) console.log('this.variant_id: ', this.variant_id);
        if (this.debug) console.log('this.variant_available: ', this.variant_available);
        if (this.debug) console.log('this.finish: ', this.finish);
      }

      prePickConfigurableSelections() {
        // pre-pick the selections based on the data attributes of the element
        if (this.debug) console.log('prePickConfigurableSelections');
        const config_model = this.querySelector('config-model');
        const config_finish = this.querySelector('config-finish');
        if (this.product_id && config_model) {
          if (this.debug) console.log('try to click this product_id: ', this.product_id);
          const config_model_buttons = config_model.querySelectorAll('[data-config-product-id]');
          config_model_buttons.forEach((config_button) => {
            if (config_button.getAttribute('data-config-product-id') === this.product_id) {
              config_button.click();
            }
          });
          if (this.variant_id && config_finish) {
            if (this.debug) console.log('try to click this variant_id: ', this.variant_id);
            const config_finish_buttons = config_finish.querySelectorAll(
              '[data-config-finish][data-config-variant-id="' + this.variant_id + '"]'
            );
            config_finish_buttons.forEach((config_button) => {
              if (config_button.getAttribute('data-config-variant-id') === this.variant_id) {
                config_button.click();
              }
            });
          }
        } else if (this.variant_id) {
          if (this.debug) console.log('try to click this variant_id: ', this.variant_id);
          const config_finish = this.querySelector('config-finish');
          const config_finish_buttons = config_finish.querySelectorAll(
            '[data-config-finish][data-config-variant-id="' + this.variant_id + '"]'
          );
          config_finish_buttons.forEach((config_button) => {
            if (config_button.getAttribute('data-config-variant-id') === this.variant_id) {
              config_button.click();
            }
          });
        }
        this.disable_pickers = false;
      }

      // Function to set up the MutationObserver
      setupObserver() {
        if (this.debug) console.log('setupObserver()');

        const configurable_product_container = document.querySelector('product-card');
        configurable_product_container.attachConfigListeners();
      }

      attachConfigListeners() {
        if (this.debug) console.log('attachConfigListeners');
        this.querySelectorAll('[data-section-state]').forEach((config_section) => {
          this.attachConfigSectionListener(config_section);
        });
      }
      attachConfigSectionListener(config_section) {
        if (this.debug) console.log('attachConfigSectionListener');
        const config_section_buttons = config_section.querySelectorAll('[data-button-state]');
        config_section_buttons.forEach((config_button) => {
          config_button.addEventListener('click', (event) => {
            event.preventDefault();

            // config_button not have attribute data-button-state='active' (to prevent double click or listeners for active button)
            if (
              config_button.hasAttribute('data-button-state') &&
              config_button.getAttribute('data-button-state') !== 'active'
            ) {
              config_section_buttons.forEach((config_button) => {
                // change value of data-button-state to "inactive"
                config_button.setAttribute('data-button-state', 'inactive');
              });
              // change value of data-button-state to "active"
              config_button.setAttribute('data-button-state', 'active');

              if (!this.disable_pickers) {
                if (config_section.tagName === 'CONFIG-MODEL') {
                  // get the value of data-default-sku
                  this.variant_id = false;
                  const data_config_sku = config_button.getAttribute('data-config-sku');
                  // set this.model to default_sku
                  this.sku = data_config_sku;
                  // set this.product_id to the value of data-config-product-id
                  this.product_id = config_button.getAttribute('data-config-product-id');
                } else if (config_section.tagName === 'CONFIG-FINISH') {
                  // reset all other filter values that come after this one
                  this.sku = config_button.getAttribute('data-config-variant-sku');
                  const data_config_finish = config_button.getAttribute('data-config-finish');
                  this.finish = data_config_finish;
                  this.product_id = config_button.getAttribute('data-config-product-id');
                  this.variant_id = config_button.getAttribute('data-config-variant-id');
                }
              }
              this.findVariant();
            }
            // can I get the next div element that's my sibling?
            // do I need to reset all the other sections to "inactive" and all their choices?
          });
        });
      }
      resetFilterValues() {
        this.finish = false;
        this.quantity = false;
        this.customize = false;
        this.bundle = false;
      }

      findVariant() {
        // find the variant within the json and update the variant loaded in the page
        if (this.debug) console.log('findVariant');
        if (this.debug) console.log('this.product_id: ', this.product_id);
        if (this.debug) console.log('this.variant_id: ', this.variant_id);
        if (this.debug) console.log('this.model: ', this.model);
        if (this.debug) console.log('this.sku: ', this.sku);
        if (this.debug) console.log('this.finish: ', this.finish);
        if (this.finish && !this.variant_id) {
          if (this.debug) console.log('try to find with finish');
          if (this.debug) console.log('this.product_id: ', this.product_id);
          if (this.debug) console.log('this.finish: ', this.finish);
          const json_config_product_variant = document.querySelector(
            `script[data-json-config-product-id="${this.product_id}"]`
          );

          if (json_config_product_variant) {
            this.selected_product_json = json_config_product_variant;
            // update the variant loaded in the page
            const this_finish = this.finish;
            this.updateSelectedVariant(json_config_product_variant, 'finish', this_finish);
          }
        } else {
          if (this.debug) console.log('try to find with just product_id and variant_id');
          // find json script that has attribute data-json-config-variant-sku="model" and parse the JSON to get the data within it
          const json_config_product_variant = document.querySelector(
            `script[data-json-config-product-id="${this.product_id}"]`
          );
          if (json_config_product_variant) {
            this.selected_product_json = json_config_product_variant;
            // update the variant loaded in the page
            const this_sku = this.sku;
            this.updateSelectedVariant(json_config_product_variant);
          }
        }
      }

      updateSelectedVariant(json_config_product_variant, selector = 'variant', selector_value = false) {
        // find the variant within the json and update the variant loaded in the page which includes swapping out the media gallery at the top of the page, updating the price, updating the summary cart, and updating the hidden inputs in the form
        if (this.debug) console.log('updateSelectedVariant');

        this.setupFinishPicker();
        this.setConfiguarableProductValues(json_config_product_variant, selector, selector_value);

        this.initializeSwipers();
        this.updateSpecsModal();
        this.updateBuyBtnUrl(json_config_product_variant);
      }

      initializeSwipers() {
        if (this.debug) console.log('initializeSwipers');

        const selectedProductSwiper = this.swipers[this.product_id];

        // no need to update sliders because the slider for the selected option does not exist
        if (!selectedProductSwiper) {
          if (this.debug) console.warn(`Swiper for product ID ${this.product_id} not found.`);
          return;
        }

        // Check if the swiper element has display: block
        const swiperElement = selectedProductSwiper.el;
        const computedStyle = window.getComputedStyle(swiperElement);

        if (computedStyle.display === 'block') {
          if (this.debug)
            console.log(`Skipping initialization for Swiper with display: block for product ${this.product_id}.`);
          this.updateSwiperSlider(selectedProductSwiper);
          return;
        }

        const allSwipers = document.querySelectorAll('.swiper-product-images-container');

        allSwipers.forEach((swiper) => {
          swiper.style.display = 'none';
        });

        this.updateSwiperSlider(selectedProductSwiper);
      }

      setupFinishPicker() {
        // hide all finish pickers first
        const finish_pickers = document.querySelectorAll('[data-config-finish]');
        finish_pickers.forEach((finish_picker) => {
          finish_picker.style.display = 'none';
        });
        // set the finish picker that has this.product_id with style display: flex
        const active_finish_pickers = document.querySelectorAll(
          `[data-config-finish][data-config-product-id="${this.product_id}"]`
        );
        active_finish_pickers.forEach((active_finish_picker) => {
          active_finish_picker.style.display = 'inline-flex';
        });
      }
      setupSwiperSliders() {
        if (this.debug) console.log('setupSwiperSliders');
        const swiperContainers = document.querySelectorAll('.swiper-product-images-container');

        // Create each Swiper instance
        swiperContainers.forEach((container) => {
          const product_id = container.dataset.swiperProductId;

          this.swipers[product_id] = new window.Swiper(container, {
            slidesPerView: 1,
            allowTouchMove: true,
            loop: true,
            pagination: {
              el: `.swiper-product-images-container[data-swiper-product-id="${product_id}"] .swiper-pagination`,
            },
            navigation: {
              nextEl: `.swiper-product-images-container[data-swiper-product-id="${product_id}"] .swiper-button-next`,
              prevEl: `.swiper-product-images-container[data-swiper-product-id="${product_id}"] .swiper-button-prev`,
            },
            breakpoints: {
              820: {
                loop: false,
              },
            },
            on: {
              afterInit: (swiper) => {
                swiper.pagination.el.style.visibility = 'visible';
                swiper.navigation.prevEl.style.visibility = 'visible';
                swiper.navigation.nextEl.style.visibility = 'visible';
              },
              breakpoint: function () {
                this.navigation.update();
              },
              touchMove: function (swiper, event) {
                if (event.touches) {
                  if (window.visualViewport.scale > 1.2) {
                    this.allowSlideNext = false;
                    this.allowSlidePrev = false;
                  }
                }
              },
              touchEnd: function (swiper, event) {
                if (event.touches) {
                  if (window.visualViewport.scale <= 1.2) {
                    this.allowSlideNext = true;
                    this.allowSlidePrev = true;
                  }
                }
              },
            },
          });
        });
      }
      updateSwiperSlider(slider) {
        if (this.debug) console.log('updateSwiperSlider');

        const containerSelector = `.swiper-product-images-container[data-swiper-product-id="${this.product_id}"]`;
        const allVariantImages = Array.from(document.querySelectorAll(`${containerSelector} [data-swiper-variant-id]`));

        const visibleSlides = allVariantImages.filter(
          (img) => img.getAttribute('data-swiper-variant-id') === this.variant_id
        );
        const hiddenSlides = allVariantImages.filter((img) => !visibleSlides.includes(img));

        // Check if all visible slides are correctly configured
        const allSlidesCorrect = visibleSlides.every(
          (slide) => slide.classList.contains('swiper-slide') && !slide.classList.contains('swiper-hidden-slide')
        );

        // Check if slides are in the correct order
        const allInCorrectOrder = allVariantImages.every((slide, index) => {
          if (hiddenSlides.includes(slide)) {
            return index < hiddenSlides.length;
          } else if (visibleSlides.includes(slide)) {
            return index >= hiddenSlides.length;
          }
          return false;
        });

        // If everything is already correct, no need to update
        if (allSlidesCorrect && allInCorrectOrder) {
          this._finalizeSliderUpdate(slider);
          if (this.debug) console.log('no need to update product swiper');
          return;
        }

        // Update slide classes
        allVariantImages.forEach((slide) => {
          const isVisible = visibleSlides.includes(slide);
          slide.classList.toggle('swiper-slide', isVisible);
          slide.classList.toggle('swiper-hidden-slide', !isVisible);
        });

        // Update Swiper instance
        this._updateSliderInstance(slider, visibleSlides);

        // Finalize updates
        this._finalizeSliderUpdate(slider);
      }

      // Private method to handle slider updates and reinitialization logic
      _updateSliderInstance(slider, visibleSlides) {
        if (slider.params.loop) {
          slider.loopDestroy();

          if (visibleSlides.length > 1) {
            // Reorder slides
            const swiperWrapper = slider.wrapperEl;
            if (swiperWrapper) {
              visibleSlides.forEach((slide) => swiperWrapper.appendChild(slide));
            }
            slider.params.loopedSlides = visibleSlides.length;
            slider.loopCreate();
            slider.slideToLoop(0, 0);
          }
        } else {
          slider.slideTo(0, 0);
        }

        slider.update();
        slider.pagination.update();
        slider.navigation.update();
      }

      // Private method to finalize slider update process
      _finalizeSliderUpdate(slider) {
        slider.el.style.display = 'block';
        if (this.debug) console.log('Slider update finalized');
      }

      updateSpecsModal() {
        if (this.debug) console.log('updateSpecsModal');

        const specsModal = document.querySelector('[data-product-specs-modal]');
        if (!specsModal) return;

        const jsonData = JSON.parse(this.selected_product_json.innerHTML);

        const targetVariant = jsonData.variants.find((variant) => variant.id === this.variant_id);
        if (!targetVariant) return;

        const imageUrl = jsonData.dimension_image;

        // Helper function to update HTML content safely
        const updateContent = (selector, content) => {
          const element = specsModal.querySelector(selector);
          if (element) {
            element.innerHTML = content;
            if (this.debug) console.log(`Updated ${selector} with content:`, content);
          } else if (this.debug) {
            console.warn(`Element with selector ${selector} not found`);
          }
        };

        // Helper function to update <picture>
        const updatePictureSource = (pictureSelector, newSrc) => {
          const pictureElement = specsModal.querySelector(pictureSelector);

          if (!pictureElement) return;

          // Update each <source> element within <picture>
          const sourceElements = pictureElement.querySelectorAll('source');
          sourceElements.forEach((source) => {
            source.setAttribute('data-srcset', newSrc);
            source.setAttribute('srcset', newSrc);
          });

          // Update the <img> element within <picture>
          const imgElement = pictureElement.querySelector('img');
          if (imgElement) {
            imgElement.setAttribute('data-src', newSrc);
            imgElement.setAttribute('src', newSrc);
          }

          if (this.debug) console.log(`Updated picture sources with new src: ${newSrc}`);
        };

        // Rebuild the spec card from the active product/variant's server-rendered rows
        // (sourced from the `custom.specifications` metaobject lists). Sanitize when
        // DOMPurify is available; the markup is theme-generated either way.
        const setSpecGroupHtml = (group, html) => {
          const container = specsModal.querySelector(`[data-spec-group="${group}"]`);
          if (!container || html == null) return;
          container.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(html) : html;
        };
        setSpecGroupHtml('product', jsonData.product_specs_html);
        setSpecGroupHtml('variant', targetVariant.variant_specs_html);

        // Warranty and SKU are native to the variant.
        updateContent('[spec-variant-warranty]', targetVariant.warranty || '');
        updateContent('[spec-variant-sku]', targetVariant.sku || '');

        // Update dimension image
        updatePictureSource('[data-product-dimension-image]', imageUrl);

        if (this.debug) console.log('Updated modal with variant:', targetVariant, 'and product specs:', jsonData.specs);
      }

      updateBuyBtnUrl(productJson) {
        const buyBarEl = document.querySelector('[data-indepth-buy-bar]');

        if (!buyBarEl) {
          if (this.debug) console.log('Buy bar not found');
          return;
        }

        const buyBtn = buyBarEl.querySelector('[data-indepth-buy-button]');
        const jsonData = JSON.parse(productJson.innerHTML);
        const targetVariant = jsonData.variants.find((variant) => variant.id === this.variant_id);

        if (buyBtn && targetVariant && targetVariant.handle) {
          const newUrl = `${window.shopUrl}/products/${targetVariant.handle}${
            targetVariant.id ? `?variant=${targetVariant.id}` : ''
          }`;
          buyBtn.href = newUrl;

          if (this.debug) console.log(`Updated buy button URL to: ${newUrl}`);
        }
      }
    }
  );
}
